<template>
   <div class="card" style="display: flex; flex-wrap: wrap !important; max-width: 100%; min-height: 450px;">
            <div style="font-size: 14px; text-align: center; width: 100vw;">
    <h2>画像をアップロードする</h2>
    <hr>
    <input
      type="file"
      name="image"
      accept="image/*"
      style="font-size: 1.2em; padding: 10px 0;"
      @change="setImage"
    >
    <br>
    <div v-if="imgSrc != ''" style="width: 200px; height:200px; border: 1px solid gray; display: inline-block;">
      <vue-cropper
        ref="cropper"
        :guides="true"
        :view-mode="2"
        drag-mode="crop"
        :auto-crop-area="0.5"
        :min-container-width="200"
        :min-container-height="200"
        :max-container-width="200"
        :max-container-height="200"

        :background="true"
        :rotatable="false"
        :src="imgSrc"
        alt="Source Image"
        :img-style="{ 'width': '200px', 'height': '200px' }"
        :aspect-ratio="6/5"
      ></vue-cropper>
          <button @click="cropImage" v-if="imgSrc != ''">トリミングする</button>

    </div>    
    <!-- <img :src="cropImg" alt="Cropped Image"> -->
        <div v-if="cropImg != ''" style="width: 240px; height:200px; border: 1px solid gray; display: inline-block;">

    <img
      :src="cropImg"
      style="width: 240px; height: 200px; border: 1px solid gray;"
      alt="Cropped Image"
    >
    <button  @click="rotate" v-if="imgSrc != ''">決定</button>
  </div>
</div></div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  components: {
    VueCropper
  },
  data() {
    return {
      imgSrc: "",
      cropImg: "",
      photo: "",
      isImageSave: false,
      }
    
    },
  methods: {
    setImage(e) {
      console.debug('*** Start *** rotate')
      console.debug('e: ' + JSON.stringify(e))
      
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        console.warn('type is not image')
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        console.info('file reader is function')
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        console.warn('file reader is not function')
        alert("Sorry, FileReader API not supported");
      }
      console.debug('*** End *** rotate')
    },
    cropImage() {
      console.debug('*** Start *** cropImage')
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      console.debug('*** End *** cropImage')
    },
    rotate() {
      console.debug('*** Start *** rotate')
      // guess what this does :)
      this.isImageSave = true;
      this.$refs.cropper.rotate(90);
      this.photo = this.cropImg;
      this.$emit('imageMethod', this.photo, this.isImageSave);
      console.debug('*** End *** rotate')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{
  font-size: 25px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/Cropperjstalk.vue